// extracted by mini-css-extract-plugin
export default {"mCard":"iE-z","image":"jE-z","imageNoBackground":"kE-z","imageHasCategory":"lE-z","fullWidth":"mE-z"};